export default {
    adjustments: {
        title: "Aanpassingen",
        reset: "Reset",
        light: {
            title: "Licht",
            brightness: "Helderheid",
            contrast: "Contrast",
            shadows: "Schaduwen",
        },
        color: {
            title: "Kleur",
            saturation: "Verzadiging",
            temperature: "Temperatuur",
            blacks: "Zwarten",
            whites: "Witten",
        },
        detail: {
            title: "Detail",
            clarity: "Helderheid",
            sharpness: "Scherpte",
            blur: "Blur",
        },
    },
};
